function safeDate(iso: string | undefined | null): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

export function relTime(iso: string): string {
  const d = safeDate(iso);
  if (!d) return "";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString();
}

export function formatDateTime(iso: string | undefined | null): string {
  return safeDate(iso)?.toLocaleString() ?? "";
}

export function formatTime(iso: string | undefined | null): string {
  return safeDate(iso)?.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) ?? "";
}
